import { useField, useFormikContext } from "formik";
import { get } from "lodash";
import { Box } from "@chakra-ui/react";

import Select from "../Select";
import { colors } from "../../../styles/theme";

const SelectField = (props) => {
  const [field, meta, { setValue, setTouched }] = useField(props);
  const { touched } = useFormikContext();

  const isTouched = get(touched, field.name);

  const error = (meta.touched || isTouched) && meta.error;

  const onChange = (data) => {
    if (props.isMulti) {
      setValue(data);
    } else {
      setValue(data?.value);
    }
  };

  const populateValues = () => {
    if (props.isMulti) {
      return field.value;
    } else {
      return props.options ? props.options.find((option) => option.value === field.value) : "";
    }
  };

  return (
    <Box className={props.className} w={props.width}>
      <Select
        data-testid="selectField"
        inputId="selectField"
        {...field}
        {...props}
        // ref={props.innerRef ?? undefined}
        value={populateValues()}
        onChange={(data) => {
          onChange(data);
          props.onChange && props.onChange(data);
        }}
        onBlur={() => setTouched(true)}
        controlStyles={
          error && {
            borderColor: colors.red,
            boxShadow: `0 0 0 1px ${colors.red}`,
          }
        }
      />
      {error && (
        <Box mt={2} color={colors.red} fontSize="sm">
          {error}
        </Box>
      )}
    </Box>
  );
};

export default SelectField;
